/**
 * «تنظیمات» — the section registry, and the one place `?section=` is decided.
 *
 * Both surfaces read this. Before it existed the list was written twice, and the
 * two copies had already drifted: the desktop sidebar carried nine sections and
 * the phone menu carried seven, so «دستیار هوشمند» and «واتس‌اپ» — the latter the
 * only place a clinic can pair its WhatsApp number — were unreachable on a phone
 * except through a detour into «کلینیک من». A registry duplicated is a registry
 * that will disagree; the only question is when.
 *
 * The active section lives in the URL (`?section=`), which `ROUTES.settings`
 * already emits and both surfaces previously ignored in favour of a local
 * `useState`. In the URL it is linkable, survives a refresh, and answers the
 * platform back gesture — none of which local state can do.
 *
 * Nothing here renders. No React, no JSX, no tokens: `icon` is an emoji STRING,
 * which the desktop sidebar and the mobile `SectionNav` each dress themselves.
 *
 * Only sections with a backend are listed. نوبت‌دهی, بیمه‌ها, امنیت and دستیار
 * هوشمند were copied from the doctor panel and saved through `me` /
 * `update*Settings`, which the clinic BFF has never served; a bookmark of one
 * of them lands on the first section, like any unknown id.
 */

export const SETTINGS_SECTIONS = (t) => ([
  { id: 'profile',       label: t('settings.sections.profile'),       icon: '👤' },
  { id: 'appearance',    label: t('settings.sections.appearance'),    icon: '🎨' },
  { id: 'whatsapp',      label: t('settings.sections.whatsapp'),      icon: '💬' },
]);

/**
 * The ids only — read through a translator that returns the key it is handed,
 * because a URL has no language. Threading a real `t` in would have turned a
 * module constant into a function and every reader into a call, for labels
 * neither the validator nor the fallback reads.
 */
export const SETTINGS_SECTION_IDS = SETTINGS_SECTIONS((key) => key).map((s) => s.id);

export const DEFAULT_SETTINGS_SECTION = 'profile';

/**
 * Which section to open. An unknown or absent `?section=` settles on the first
 * one rather than rendering blank — a bookmark of a section that was renamed
 * must land somewhere real (docs/MOBILE-REDESIGN.md §3.4).
 */
export function resolveSettingsSection(requested) {
  return SETTINGS_SECTION_IDS.includes(requested) ? requested : DEFAULT_SETTINGS_SECTION;
}

/** The label of one section, for a header title. */
export function settingsSectionLabel(id, t) {
  return SETTINGS_SECTIONS(t).find((s) => s.id === id)?.label || '';
}
